<template>
  <div>
    <viewTable
      ref="viewTable"
      :limits="limits"
      :columns-property="columnsProperty"
      :filter="filter"
      module="basic"
      url="codeRules"
      :table-select="false"
      @addOrEdit="addEditHandle"
      @delete="deleteHandle"
      @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="规则名称">
            <el-input v-model.trim="filter.tableName" placeholder="请输入规则名称" clearable />
          </el-form-item>
          <el-form-item label="编码前缀">
            <el-input v-model.trim="filter.prefix" placeholder="请输入编码前缀" clearable />
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <EncodingRulesEdit ref="encodingRulesEdit" @save-success="loadData"></EncodingRulesEdit>
  </div>
</template>

<script>
import viewTable from "@/components/ViewTable.vue";
import EncodingRulesEdit from "./EncodingRulesEdit";
export default {
  components: { viewTable, EncodingRulesEdit },
  data() {
    return {
      limits: {
        addAuth: this.$auth(281),
        editAuth: this.$auth(282),
        delAuth: this.$auth(283),
      },
      filter: {
        tableName: "",
        prefix: "",
      },
      columnsProperty: [
        {
          key: "tableName",
          minWidth: 200,
          tooltip: true,
        },
        {
          key: "describe",
          minWidth: 200,
          tooltip: true,
        },
        {
          key: "prefix",
          width: 140,
          tooltip: true,
        },
        {
          tooltip: true,
          key: "iDLength",
          width: 120,
          render: (h, params) => {
            return h("span", params.row.idlength);
          },
        },
        {
          tooltip: true,
          key: "curID",
          width: 120,
        },
        {
          key: "action",
          align: "center",
          width: 140,
          slot: "action",
          fixed: "right",
        },
      ],
    };
  },
  methods: {
    // 新增、编辑
    addEditHandle(row) {
      this.$refs.encodingRulesEdit.open(row);
    },

    // 加载数据
    loadData(pageNum) {
      this.$refs.viewTable.loadData(pageNum);
    },

    // 删除
    deleteHandle(row) {
      this.$http.delete("basic", "codeRules", row.pkId).then((resp) => {
        if (resp.success) {
          this.loadData();
          this.$message.success("删除成功");
        }
      });
    },

    resetHandle(filter) {
      this.filter = filter;
    },
  },
};
</script>
